module.exports = __webpack_public_path__ + "img/usage.214f9b84.png";